module.exports = __webpack_public_path__ + "static/media/1.4ac2905b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/case/fat_tiger/1.jpg
 ** module id = 621
 ** module chunks = 0
 **/